import { SiBitcoin, SiEthereum, SiLitecoin, SiRipple, SiBitcoincash, SiStellar, SiTether } from 'react-icons/si';
import { GiGoldBar } from 'react-icons/gi';

export const INITIAL_MARKETS = [
    { id: 11, symbol: 'XAU', pair: 'Gold/USD', price: '4915.42', change: '+1.38%', isUp: true },
    { id: 12, symbol: 'XAU', pair: 'Gold/EURO', price: '4560.30', change: '+1.20%', isUp: true },
    { id: 1, symbol: 'BTC', pair: 'BTC/USDT', price: '92201.00', change: '+1.47%', isUp: true },
    { id: 2, symbol: 'ETH', pair: 'ETH/USDT', price: '3157.36', change: '+1.26%', isUp: true },
    { id: 3, symbol: 'LTC', pair: 'LTC/USDT', price: '79.24', change: '-1.50%', isUp: false },
    { id: 4, symbol: 'XRP', pair: 'XRP/USDT', price: '2.09612', change: '+0.31%', isUp: true },
    { id: 5, symbol: 'BCH', pair: 'BCH/USDT', price: '648.15', change: '-1.03%', isUp: false },
    { id: 6, symbol: 'HBAR', pair: 'HBAR/USDT', price: '0.119531', change: '+2.25%', isUp: true },
    { id: 7, symbol: 'USDC', pair: 'USDC/USDT', price: '1.0011', change: '+0.00%', isUp: true },
    { id: 8, symbol: 'XLM', pair: 'XLM/USDT', price: '0.227993', change: '+1.13%', isUp: true },
    { id: 9, symbol: 'AVAX', pair: 'AVAX/USDT', price: '14.0714', change: '+1.92%', isUp: true },
    { id: 10, symbol: 'ETC', pair: 'ETC/USDT', price: '12.6322', change: '+1.37%', isUp: true },
];

export const CRYPTO_ICONS = {
    BTC: SiBitcoin,
    ETH: SiEthereum,
    LTC: SiLitecoin,
    XRP: SiRipple,
    BCH: SiBitcoincash,
    XLM: SiStellar,
    ETC: SiEthereum,
    XAU: GiGoldBar,
    USDT: SiTether,
    USDC: SiTether, // Fallback to Tether icon until a better one is found
};

/**
 * Maps display symbols to actual Binance trading pair symbols.
 * This ensures consistency between Dashboard and Trade page.
 * @param {string} displaySymbol - The symbol shown in the UI (e.g., "GOLDUSD", "BTCUSDT")
 * @returns {string} - The actual Binance symbol (e.g., "PAXGUSDT", "BTCUSDT")
 */
export const getBinanceSymbol = (displaySymbol) => {
    const upperSymbol = (displaySymbol || '').toUpperCase();

    // Gold mappings - PAXG is Binance's gold-backed token
    if (upperSymbol.includes('GOLD') || upperSymbol.includes('XAU')) {
        return 'PAXGUSDT';
    }

    // Standard crypto pairs - return as-is (they work directly with Binance)
    return upperSymbol;
};

/**
 * Checks if a symbol requires mock/simulated data (no Binance equivalent).
 * @param {string} displaySymbol - The symbol to check
 * @returns {boolean} - True if mock data should be used
 */
export const requiresMockData = (displaySymbol) => {
    const upperSymbol = (displaySymbol || '').toUpperCase();
    // EURO pairs don't exist on Binance
    return upperSymbol.includes('EURO');
};
